/** @jsxImportSource @emotion/react */
import { COLUMN_SPACING } from "../../forms/styles";
import { MODAL_SIZE } from "../../layout/modal/modalSize";
import ModalTitleHeader from "../../layout/modal/ModalTitleHeader";
import ModalView, { ModalContent } from "../../layout/modal/ModalView";
import { useSelector } from "react-redux";
import { IAppState } from "../../core/redux/IAppState";
import { getResource } from "../../language/resources/getResource";
import hotlistIcon from "../../assets/icons/flame.svg";
import { doNothing } from "../../language/module";
import { Column } from "../../layout/flexbox";
import HotlistReportParameters from "./HotlistReportParameters";
import { css } from "@emotion/react";

const hotlistReportWidth = css`
  width: 450px;
  min-width: 450px !important;
`;

const hotlistReportContentStyle = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${COLUMN_SPACING};
`;

type Props = {
  onDismiss?: () => void;
};

export const HotlistReportModal = (props: Props) => {
  const resources = useSelector((state: IAppState) => state.locale);

  const onCloseReport = () => (props.onDismiss || doNothing)();

  return (
    <ModalView
      rootCss={hotlistReportWidth}
      onDismiss={onCloseReport}
      size={MODAL_SIZE.X_SMALL}
      contentCss={hotlistReportContentStyle}
      disableClickoffDismissable={true}
    >
      <ModalTitleHeader
        resources={resources}
        onDismiss={onCloseReport}
        heading={getResource(resources, "REPORTS_HOTLIST_REPORT")}
        icon={hotlistIcon}
      />
      <ModalContent>
        <Column rootCss={COLUMN_SPACING}>
          <HotlistReportParameters />
        </Column>
      </ModalContent>
    </ModalView>
  );
};
